import React from "react"
import Layout from "../components/layout"
import layoutStyles from "../components/layout.module.scss"
import { Link, graphql, useStaticQuery } from 'gatsby'

const BlogPage = () => {
    const data = useStaticQuery(graphql `
    query {
        allMarkdownRemark {
          edges {
            node{
              frontmatter{title date}
              fields{ slug }
            }
          }
        }
      }
    `)
    //console.log(data)
    const dataArray = data.allMarkdownRemark.edges
    //console.log(dataArray)

    return (
        <Layout>
            <h2>Welcome to my blog.</h2>
            <div className ="text-grid-1">
            <p> You will find writing on a variety of topics that revolve around code, art and graphic design. If you would like me to write about something for you, please don't hesitate to contact me.</p>
            </div>
            <ol>
                {dataArray.map(( edge ) => {
                    return(
                        <div>
                          <Link  className ={layoutStyles.blogTitles} to = {`/blog/${edge.node.fields.slug}`}>
                            <h3>{ edge.node.frontmatter.title }</h3>
                            <p>{ edge.node.frontmatter.date }</p>
                            </Link>
                        </div>
                    )
                })}
            </ol>
        </Layout>
    )
}

export default BlogPage